import { useMutation } from '@tanstack/react-query'

import { IStorageService } from '@/services/contracts/storage'
import { queryClient } from '@/providers/libs/query-client'
import { useParams } from 'react-router-dom'

type DownloadProps = {
  storageService: IStorageService
}

export function useDeleteImage({ storageService }: DownloadProps) {
  const { id } = useParams()

  const { mutateAsync, isPending, error, data } = useMutation({
    mutationFn: (image_id: string) =>
      storageService.deleteImage({ image_id, institution_id: id }),
    mutationKey: ['download'],
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [`list_institution`, id],
      })
    },
  })

  const [response, errorResponse] = data || [{ url: null }, null]

  return {
    url: response?.url || '',
    deleteImage: mutateAsync,
    errorDelete: error || errorResponse,
    isLoadingDelete: isPending,
  }
}
